import {inject, Injectable} from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import {environment} from "../../../environments/environment";
import {PreviewService} from '../services/preview.service';
import {Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class PreviewInterceptor implements HttpInterceptor {
  previewService = inject(PreviewService);


  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let request = req;
    let prev = this.previewService.getPreviewId();
    let documentGuid = this.previewService.getDocumentGuid(request.url);

    if (prev && req.url.includes("/api/")) {
      const headers = new HttpHeaders()
        .set(environment.previewKey, prev)
        .set('Preview', Math.random().toString())
        .set('version', new Date().getTime().toString())
        .set('DocumentGuid', documentGuid ?? '');
        request = req.clone({headers: headers});
    }
    return next.handle(request);
  }
}

